import { useState } from "react";
import "../styles/main.css";

function Admission({ mode }) {

  // 🔥 CHANGE THIS ONLY WHEN HOSTING
  const API_URL = "http://localhost:5000"; 
  // 👉 AFTER HOSTING replace with:
  // const API_URL = "https://your-backend.onrender.com";

  // STATE
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    dob: "",
    course: "",
    phone: "",
    email: "",
    address: ""
  });

  // HANDLE INPUT CHANGE
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // HANDLE SUBMIT
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch(`${API_URL}/api/admission`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ ...formData, mode })
      });

      const data = await res.json();

      if (data.status === "success") {
        alert("✅ Admission Submitted Successfully!");

        setFormData({
          firstName: "",
          lastName: "",
          dob: "",
          course: "",
          phone: "",
          email: "",
          address: ""
        });

      } else {
        alert("❌ Error submitting form");
      }

    } catch (error) {
      console.log("Error ❌", error);
      alert("❌ Cannot connect to server");
    }
  };

  return (
    <div className="admission">

      <h2 className="admission-title">Admissions 2026-27</h2>

      <div className="admission-container">

        {/* LEFT SIDE */}
        <div className="admission-left">

          <h3>Admission Process</h3>

          <div className="process">
            <div><span>01</span><p><b>Online Registration</b><br />Fill inquiry form</p></div>
            <div><span>02</span><p><b>Document Verification</b><br />Submit documents</p></div>
            <div><span>03</span><p><b>Counseling</b><br />Guidance session</p></div>
            <div><span>04</span><p><b>Fee Payment</b><br />Complete admission</p></div>
          </div>

          <h3>Required Documents</h3>

          <ul className="documents">
            {mode === "school" ? (
              <>
                <li>Birth Certificate</li>
                <li>Aadhaar Card</li>
                <li>Child Photo</li>
              </>
            ) : (
              <>
                <li>Aadhar Card</li>
                <li>12th Marksheet</li>
                <li>10th Marksheet</li>
                <li>TC</li>
              </>
            )}
          </ul>
        </div>

        {/* RIGHT FORM */}
        <div className="admission-right">

          <h3>Registration Form</h3>

          <form className="admission-form" onSubmit={handleSubmit}>

            <div className="form-row">
              <div className="form-group">
                <label>First Name</label>
                <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} required />
              </div>

              <div className="form-group">
                <label>Last Name</label>
                <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} required />
              </div>
            </div>

            <div className="form-group">
              <label>Date of Birth</label>
              <input type="date" name="dob" value={formData.dob} onChange={handleChange} required />
            </div>

            <div className="form-group">
              <label>{mode === "school" ? "Select Class" : "Select Course"}</label>
              <select name="course" value={formData.course} onChange={handleChange} required>
                <option value="">-- Select --</option>
                {mode === "school" ? (
                  <>
                    <option>Play Group</option>
                    <option>Nursery</option>
                    <option>Junior KG</option>
                    <option>Senior KG</option>
                  </>
                ) : (
                  <>
                    <option>B.A</option>
                    <option>B.Sc</option>
                    <option>B.Com</option>
                  </>
                )}
              </select>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Phone</label>
                <input type="tel" name="phone" value={formData.phone} onChange={handleChange} required />
              </div>

              <div className="form-group">
                <label>Email</label>
                <input type="email" name="email" value={formData.email} onChange={handleChange} required />
              </div>
            </div>

            <div className="form-group">
              <label>Address</label>
              <textarea name="address" value={formData.address} onChange={handleChange} required />
            </div>

            <button type="submit">Submit</button>

          </form>

        </div>

      </div>
    </div>
  );
}

export default Admission;